import { Badge, Popconfirm, Tooltip, Tour } from "antd";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  HeaderUser,
  IconDetyrat,
  IconDil,
  IconNojftimet,
  LogoFlex,
  QotdIcon,
  DocumentationWarningIcon,
  IntervistatIcon,
  KonfigurimetIcon,
  ChartIcon,
  ContactsIcon,
} from "../../../assets/icons";
import "../header.scss";
import { weatherIconPicker } from "./weatherIconPicker";
import Clock from "../../../utils/LiveClock";
import {
  getCompanyTimezone,
  PRISHTINA_TZ,
} from "../../../utils/timezone/teamTimezone";
import { HollowDotsSpinner } from "react-epic-spinners";
import EditQOTD from "./EditQOTD";
import QotdQuote from "./QotdQuote";
import EditQuoteOfTheDay, {
  useCanEditQotd,
} from "../../commonComponents/EditQuoteOfTheDay/EditQuoteOfTheDay";
import { useMediaQuery } from "react-responsive";
import { useParams } from "react-router-dom";
import { API } from "../../../helpers/API/amplifyApi";
import useOpenOnce from "../../../hooks/useOpenOnce";
import ThemeToggle from "./ThemeToggle";
import { useAuth } from "../../../authentication/authHelpers";
import { useSelector } from "react-redux";
import { eventTracker } from "../../../utils/eventTracker";

function KryefaqjaHeader({
  qotd,
  location,
  dataWeather,
  fToCelTirana,
  setToggleTirana,
  toggleTirana,
  togglePrishtina,
  fToCelPristina,
  setTogglePrishtinas,
  fToCel,
  setToggle,
  toggle,
  setOpenContactsModal,
  userPhoto,
  setRequestsActive,
  requestsActive,
  pendingRequest,
  setNotifsActive,
  notifsActive,
  setOpenStats,
  handleLogOut,
  count,
  setQotd,
  setProblemsActive,
  problemsActive,
  problematikatCount,
  candidatesCount,
  interviewActive,
  setInterviewActive,
  browserPushToggle = null,
}) {
  const auth = useAuth();
  const companyContacts = useRef();
  const { employeeId } = useParams();
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [employee, setEmployee] = useState(null);
  const [editingQotd, setEditingQotd] = useState(false);
  const canEditQotd = useCanEditQotd();

  const [openFeatureAlert, setOpenFeatureAlert] = useOpenOnce(
    "companyContacts",
    "newFeature"
  );

  // Large desktop: show Tirana / Prishtina / NY clocks + weather
  const isMobileView = useMediaQuery({
    query: "(min-width: 1100px)",
  });

  const getEmployee = async () => {
    const user = await API.get("employees", `/employees/${employeeId}`);
    setEmployee(user);
  };

  useEffect(() => {
    if (!!employeeId) {
      getEmployee();
    } else {
      setEmployee(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId]);

  const steps = [
    {
      title: "🚀 New Feature!",
      description: "Kliko për të parë kontaktet e kompanisë.",
      target: () => companyContacts.current,
    },
  ];
  const isAdmin =
    auth?.user?.userRole === "Admin" || auth?.user?.userRole === "Super Admin";

  return (
    <div
      className="header-row"
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignContent: "center",
        paddingLeft: "10px",
      }}
    >
      <div
        className={`col-header-name qotd ${
          location.pathname.includes("/punonjesit/specifikat/")
            ? "specs-employee-header"
            : ""
        }`}
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          height: "100%",
          maxHeight: "70px",
        }}
      >
        {location.pathname.includes("/punonjesit/specifikat/") ? (
          !!employee ? (
            <span
              className="specs-employee-title"
              title={`${employee?.employeeFirstName || ""} ${
                employee?.employeeLastName || ""
              }`.trim()}
            >
              {`${employee?.employeeFirstName || ""} ${
                employee?.employeeLastName || ""
              }`.trim()}
            </span>
          ) : (
            <div className="specs-employee-title specs-employee-loading">
              <HollowDotsSpinner color="#1da193" size={20} />
            </div>
          )
        ) : (
          <div
            className="editQOTD"
            style={{
              paddingRight: isMobileView ? "0px" : "20px",
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "8px",
                height: "100%",
              }}
            >
              <QotdIcon fill={isDarkMode ? "#bfbfbf" : "#142735"} />
              {/* winter */}
              {/* <QotdIcon fill="#dce4e9" /> */}
              <EditQOTD onEdit={() => setEditingQotd(true)} />
            </span>
            <QotdQuote
              {...{
                qotd,
                isDarkMode,
                canEdit: canEditQotd,
                onEdit: () => setEditingQotd(true),
              }}
            />

            <EditQuoteOfTheDay
              open={editingQotd}
              quote={qotd}
              onCancel={() => setEditingQotd(false)}
              onSaved={(saved) => {
                setQotd({
                  quote: saved.quote,
                  quoteEn: "",
                  author: saved.author,
                });
                setEditingQotd(false);
              }}
            />
          </div>
        )}
      </div>
      <div className="header-weather-actions">
        <div className="icons-div">
          {isMobileView && (
            <div className="times-div">
              <div className="time-weather-div">
                Tiranë:&nbsp;
                <Clock
                  format={"HH:mm"}
                  ticking={true}
                  timezone={getCompanyTimezone()}
                />
                {!!dataWeather && !!fToCelTirana ? (
                  <span
                    className="fahrenheit-span"
                    onClick={() => setToggleTirana(!toggleTirana)}
                  >
                    {toggleTirana ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {weatherIconPicker(
                          dataWeather?.tirana?.weather[0]?.main
                        )}
                        &nbsp;
                        {dataWeather?.tirana?.main?.temp}&nbsp;&#8457;
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {weatherIconPicker(
                          dataWeather?.tirana?.weather[0]?.main
                        )}
                        &nbsp;
                        {Math.round(fToCelTirana)} &#8451;
                      </div>
                    )}
                  </span>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <HollowDotsSpinner color="#1da193" size={20} />
                  </div>
                )}
              </div>
              <h1 style={{ paddingLeft: "10px", paddingRight: "10px" }}>|</h1>
              <div className="time-weather-div">
                Prishtinë:&nbsp;
                <Clock
                  format={"HH:mm"}
                  ticking={true}
                  timezone={PRISHTINA_TZ}
                />
                {!!dataWeather && !!fToCelPristina ? (
                  <span
                    className="fahrenheit-span"
                    onClick={() => setTogglePrishtinas(!togglePrishtina)}
                  >
                    {togglePrishtina ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {weatherIconPicker(
                          dataWeather?.pristina?.weather[0]?.main
                        )}
                        &nbsp;
                        {dataWeather?.pristina?.main?.temp}&nbsp;&#8457;
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {weatherIconPicker(
                          dataWeather?.pristina?.weather[0]?.main
                        )}
                        &nbsp;
                        {Math.round(fToCelPristina)} &#8451;
                      </div>
                    )}
                  </span>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <HollowDotsSpinner color="#1da193" size={20} />
                  </div>
                )}
              </div>{" "}
              <h1 style={{ paddingLeft: "10px", paddingRight: "10px" }}>|</h1>
              <div className="time-weather-div">
                New York:&nbsp;
                <Clock
                  format={"HH:mm "}
                  ticking={true}
                  timezone={"America/New_York"}
                />
                {!!dataWeather && !!fToCel ? (
                  <span
                    className="fahrenheit-span"
                    onClick={() => setToggle(!toggle)}
                  >
                    {toggle ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {weatherIconPicker(
                          dataWeather?.newyork?.weather[0]?.main
                        )}
                        &nbsp;
                        {Math.round(fToCel)} &#8451;
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {weatherIconPicker(
                          dataWeather?.newyork?.weather[0]?.main
                        )}
                        &nbsp;
                        {dataWeather?.newyork?.main?.temp}&nbsp;&#8457;
                      </div>
                    )}
                  </span>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <HollowDotsSpinner color="#1da193" size={20} />
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="icons">
            <ThemeToggle />
            <div
              ref={companyContacts}
              onClick={() => setOpenContactsModal(true)}
            >
              <Tooltip placement="bottom" title="Kontaktet e kompanisë">
                <ContactsIcon fill="#fbfbfb" />
              </Tooltip>
            </div>
            {userPhoto?.length > 0 && userPhoto !== null ? (
              <Tooltip
                placement="top"
                title={
                  <img
                    src={userPhoto}
                    alt="Flex"
                    width={150}
                    height={150}
                    style={{ borderRadius: 5 }}
                  />
                }
              >
                <Link to="/konfigurimet/kompania/profili">
                  <img
                    src={userPhoto}
                    alt="Flex"
                    width={32}
                    height={32}
                    style={{ borderRadius: 5 }}
                  />
                </Link>
              </Tooltip>
            ) : (
              <Tooltip
                placement="top"
                title={`${auth?.user?.given_name} ${auth?.user?.family_name}`}
              >
                <Link to="/konfigurimet/kompania/profili">
                  <HeaderUser />
                </Link>
              </Tooltip>
            )}
            {isAdmin ? (
              <div onClick={() => setOpenStats((prev) => !prev)}>
                <Tooltip placement="bottom" title="Grafiku organizativ">
                  <ChartIcon />
                </Tooltip>
              </div>
            ) : null}
            {isAdmin ? (
              <div onClick={() => setRequestsActive(!requestsActive)}>
                <Badge
                  className="notification-badge"
                  count={pendingRequest?.length}
                >
                  <Tooltip placement="bottom" title="Pushimet vjetore">
                    <IconDetyrat />
                  </Tooltip>
                </Badge>
              </div>
            ) : null}
            {isAdmin ? (
              <div onClick={() => setInterviewActive(!interviewActive)}>
                <Badge className="notification-badge" count={candidatesCount}>
                  <Tooltip placement="bottom" title="Intervistat e kësaj jave">
                    <IntervistatIcon fill="white" />
                  </Tooltip>
                </Badge>
              </div>
            ) : null}
            {isAdmin ? (
              <div onClick={() => setProblemsActive(!problemsActive)}>
                <Badge
                  className="notification-badge"
                  count={problematikatCount}
                >
                  <Tooltip placement="bottom" title="Support">
                    <DocumentationWarningIcon
                      fill="white"
                      height={17}
                      width={18}
                    />
                  </Tooltip>
                </Badge>
              </div>
            ) : null}

            {browserPushToggle}
            <div
              onClick={() => {
                setNotifsActive((prev) => !prev);
                eventTracker("Header", "click", "Opened notifications drawer");
              }}
            >
              <Badge className="notification-badge" count={count?.length}>
                <Tooltip placement="bottom" title="Njoftimet">
                  <IconNojftimet />
                </Tooltip>
              </Badge>
            </div>
            <Link to="/konfigurimet/kompania/profili">
              <Tooltip placement="bottom" title="Konfigurimet">
                <KonfigurimetIcon fill="white" />
              </Tooltip>
            </Link>

            <Popconfirm
              placement="left"
              title={"A jeni të sigurt që dëshironi të dilni nga programi?"}
              onConfirm={handleLogOut}
              okText="Po"
              cancelText="Jo"
              classNames={{
                root: `popup-logout-modal globalPopover ${
                  isDarkMode ? "dark" : ""
                }`,
              }}
              icon={<LogoFlex width={45} height={45} />}
            >
              <Tooltip placement="bottom" title="Dil">
                <IconDil />
              </Tooltip>
            </Popconfirm>
          </div>
        </div>
      </div>
      {openFeatureAlert ? (
        <Tour
          open={openFeatureAlert}
          mask={{ color: "#2a2b3a71" }}
          steps={steps}
          classNames={{ root: "newFeatureTour" }}
          onClose={() => setOpenFeatureAlert(false)}
        />
      ) : null}
    </div>
  );
}

export default KryefaqjaHeader;
